import { grey } from '@material-ui/core/colors';

export default (theme) => ({
  addUserButton: {
    marginTop: 0,
    height: 55,
  },
  rightIcon: { marginLeft: theme.spacing(1) },
  textField: {
    marginLeft: 10,
    marginRight: 10,
    width: 200,
  },
  container: {
    textAlign: 'center',
    flexWrap: 'wrap',
  },
  divider: { margin: '5' },
  icon: {
    margin: theme.spacing(2),
    color: grey[500],
  },
  disclaimer: {
    display: 'flex',
    lineHeight: 1,
    alignItems: 'flex-end',
    padding: '.5em',
    background: grey[100],
  },
  flex: { flex: 1 },
  usersContainer: {
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(10),
    padding: theme.spacing(2),
  },
  textCenter: { textAlign: 'center' },
  headerContentDivider: { marginTop: theme.spacing(3) },
  description: {
    textAlign: 'center',
    marginBottom: 8,
    marginTop: 8,
  },
  addAnotherUserButtonContainer: { textAlign: 'center' },
  addAnotherUserButton: { margin: 8 },
});
